import { vars } from "@/shared/lib";

interface SessionTimeoutModalProps {
	onContinue: () => void;
	remainingMinutes: number;
}

function SessionTimeoutModal({ onContinue, remainingMinutes }: SessionTimeoutModalProps) {
	return (
		<div
			style={{
				padding: vars.size[24],
				display: "flex",
				flexDirection: "column",
				gap: vars.size[16],
				minWidth: "320px"
			}}
		>
			<h3
				style={{
					margin: 0,
					fontSize: vars.size[18],
					fontWeight: 600
				}}
			>
				세션 만료 안내
			</h3>
			<p
				style={{
					margin: 0,
					color: vars.color.gray[600],
					lineHeight: 1.5
				}}
			>
				{remainingMinutes}분 후 자동 로그아웃됩니다.
				<br />
				계속 사용하시려면 아래 버튼을 클릭하세요.
			</p>
			<button
				type="button"
				onClick={onContinue}
				style={{
					padding: `${vars.size[12]} ${vars.size[24]}`,
					backgroundColor: vars.color.main[1],
					color: "white",
					border: "none",
					borderRadius: vars.size[8],
					fontSize: vars.size[16],
					fontWeight: 500,
					cursor: "pointer"
				}}
			>
				계속 사용
			</button>
		</div>
	);
}

export default SessionTimeoutModal;
